export default {
  testDrive: {
    getTestDriveOrderList: ['get', '/test_drive/orders'],
    testDriveTrace: ['put', '/test_drive/:orderId/trace'],
  },
};
